// src/components/BackgroundWrapper.js
import React from 'react';

const BackgroundWrapper = ({ children }) => {
    const styles = {
        wrapper: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #0f0f23 100%)',
            zIndex: -1,
        },
        content: {
            position: 'relative',
            zIndex: 1,
            width: '100%',
            minHeight: '100vh',
            margin: 0,
            padding: 0,
            color: '#ffffff',
        }
    };

    return (
        <>
            <div style={styles.wrapper} />
            <div style={styles.content}>
                {children}
            </div>
        </>
    );
};

export default BackgroundWrapper;